$(function () {

    $("#search-input").attr("readonly", false);

    $("#search-form .input-group").dropdown();

    $("#search-form .input-group").on("click change paste keyup", function () {

        $("#search-form .input-group").dropdown('toggle');
    });

    $(document).click(function(event) {
        if(!$(event.target).closest('#search-form').length) {
            if($('#search-options-dropdown-box').parent().hasClass("open")) {
                $('#search-options-dropdown-box').parent().removeClass("open");
            }
        }
    });
});


/**
 * SEARCH IN PAGE
 */


var TRange=null;

function findString (str) {
    if (parseInt(navigator.appVersion)<4) return;
    var strFound;
    if (window.find) {

        // CODE FOR BROWSERS THAT SUPPORT window.find

        strFound=self.find(str);
        if (!strFound) {
            strFound=self.find(str,0,1);
            while (self.find(str,0,1)) continue;
        } else {
            if (window.getSelection) {
                if (window.getSelection().empty) {  // Chrome
                    window.getSelection().empty();
                } else if (window.getSelection().removeAllRanges) {  // Firefox
                    window.getSelection().removeAllRanges();
                }
            } else if (document.selection) {  // IE?
                document.selection.empty();
            }
        }
    }
    else if (navigator.appName.indexOf("Microsoft")!=-1) {

        // EXPLORER-SPECIFIC CODE

        if (TRange!=null) {
            TRange.collapse(false);
            strFound=TRange.findText(str);
            //if (strFound) TRange.select();
        }
        if (TRange==null || strFound==0) {
            TRange=self.document.body.createTextRange();
            strFound=TRange.findText(str);
            //if (strFound) TRange.select();
        }
    }
    else if (navigator.appName=="Opera") {
        //alert ("Opera browsers not supported, sorry...")
        return;
    }
    //if (!strFound) alert ("String '"+str+"' not found!")
    return;
}
